<div class="modal-header">
  <h4 class="modal-title"><i class="fa fa-plus-circle"></i> Add LCD Policy</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="policy-form">
    <!-- CPT mode toggle -->
    <div class="form-group">
      <label><i class="fa fa-hashtag"></i> CPT Code <span class="required">*</span></label>
      <div class="mode-toggle">
        <button
          type="button"
          class="mode-toggle__btn"
          [class.mode-toggle__btn--active]="mode === 'single'"
          (click)="setMode('single')"
          [disabled]="isSubmitting"
        >
          Single Code
        </button>
        <button
          type="button"
          class="mode-toggle__btn"
          [class.mode-toggle__btn--active]="mode === 'range'"
          (click)="setMode('range')"
          [disabled]="isSubmitting"
        >
          Range
        </button>
      </div>

      <div class="cpt-inputs">
        <input
          type="text"
          class="form-control input-nice"
          [(ngModel)]="cptFrom"
          [placeholder]="mode === 'range' ? 'From (e.g. 100)' : 'e.g. 99213'"
          maxlength="20"
          [disabled]="isSubmitting"
        />
        <ng-container *ngIf="mode === 'range'">
          <span class="cpt-inputs__sep">to</span>
          <input
            type="text"
            class="form-control input-nice"
            [(ngModel)]="cptTo"
            placeholder="To (e.g. 200)"
            maxlength="20"
            [disabled]="isSubmitting"
          />
        </ng-container>
      </div>
      <small class="hint" *ngIf="mode === 'range'">
        Creates one record for every numeric code from the start to the end of the range, inclusive.
      </small>
    </div>

    <!-- LCD File search-select -->
    <div class="form-group file-picker">
      <label for="lcdFileSearch"><i class="fa fa-file-text-o"></i> LCD File <span class="required">*</span></label>
      <input
        id="lcdFileSearch"
        type="text"
        class="form-control input-nice"
        [(ngModel)]="fileSearchTerm"
        (input)="onFileSearchInput()"
        (focus)="focusFileSearch()"
        placeholder="Search LCD files by name…"
        autocomplete="off"
        [disabled]="isSubmitting"
      />

      <div class="file-picker__results" *ngIf="showResults">
        <div class="file-picker__loading" *ngIf="isSearching">
          <i class="fa fa-spinner fa-spin"></i> Searching…
        </div>
        <ul class="file-picker__list" *ngIf="!isSearching && fileResults.length">
          <li *ngFor="let file of fileResults" (click)="selectFile(file)">
            <span class="file-picker__name">{{ file.file_name }}</span>
            <span class="file-picker__payer">{{ file.payer }}</span>
          </li>
        </ul>
        <div class="file-picker__empty" *ngIf="!isSearching && !fileResults.length">
          No LCD files found.
        </div>
      </div>

      <div class="selected-file" *ngIf="selectedFile">
        <div class="selected-file__info">
          <i class="fa fa-file-text-o"></i>
          <div>
            <div class="selected-file__name">{{ selectedFile.file_name }}</div>
            <div class="selected-file__payer">Payer: {{ selectedFile.payer }}</div>
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSelectedFile()" [disabled]="isSubmitting">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="info-message">
      <i class="fa fa-info-circle"></i>
      <span>The payer for this policy is taken automatically from the selected LCD file.</span>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="activeModal.dismiss()" [disabled]="isSubmitting">Cancel</button>
  <button class="btn btn-primary" (click)="submit()" [disabled]="isSubmitting">
    <i class="fa" [ngClass]="{ 'fa-spinner fa-spin': isSubmitting, 'fa-paper-plane': !isSubmitting }"></i>
    <span class="ml-1">Submit</span>
  </button>
</div>
